module.exports = __webpack_public_path__ + "static/media/eduBlack.027b3f5b.svg";